import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { LocalStorageService } from '../services/local-storage.service';
import { STORAGE } from '../constants';
import useBgPages from '../hooks/use-bg-pages.hook';
import { HttpCancelService } from '../services/http-cancel.service';

export const PrivateRoute = () => {
  const [checking, setChecking] = useState(true);
  const [redirectTo, setRedirectTo] = useState<string | null>(null);
  const location = useLocation();

  useEffect(() => {
    const session = LocalStorageService.get(STORAGE.SESSION);
    const token = LocalStorageService.get(STORAGE.TOKEN);
    const path = location.pathname;

    if (path.startsWith('/recovery-password') || path.startsWith('/changelog')) {
      setRedirectTo(null);
      setChecking(false);
      return;
    }

    if (!session || !token) {
      setRedirectTo('/auth/login');
      setChecking(false);
      return;
    }

    setRedirectTo(null);
    setChecking(false);
  }, [location.pathname]);

  if (checking) return null;

  if (redirectTo) return <Navigate to={redirectTo} replace />;

  return <Outlet />;
};

export const LayoutRoute = () => {
  useBgPages();
  const location = useLocation();

  useEffect(() => {
    return () => {
      HttpCancelService.cancelAll('route-change');
    };
  }, [location.pathname, location.search]);

  return <Outlet />;
};
